import React from 'react';
import { ApolloProvider } from '@apollo/client';
import Report1099Form from './Report1099Form';
import { Report1099Fields } from './types';
import { graphqlClient } from 'bk-web-app';

type report1099FormWrapperprops = {
  clientId: string;
  fields: {
    contractor: Report1099Fields;
    source: Report1099Fields;
  };
};

const Report1099FormWrapper = ({ clientId, fields }: report1099FormWrapperprops) => (
  <ApolloProvider client={graphqlClient}>
    <Report1099Form clientId={clientId} fields={fields} />
  </ApolloProvider>
);

export default React.memo(Report1099FormWrapper);
